import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './RecentActivity.css';
import NotificationsContainer from 'components/header/NotificationsContainer';

class RecentActivity extends Component {
  static propTypes = {
    title: PropTypes.string,
    recentActivity: PropTypes.shape(),
    onPageChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: 'Recent Activity',
    recentActivity: null,
  };

  constructor(props) {
    super(props);

    this.state = { currentPage: 1 };
  }

  componentDidMount() {
    this.handlePageChange(1);
  }

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
    this.props.onPageChange(page);
  };

  render() {
    const { title, recentActivity } = this.props;
    const { currentPage } = this.state;
    return (
      recentActivity && (
        <div className="recent-activity">
          <div className="recent-activity-title">{title}</div>
          <NotificationsContainer
            recentActivity={true}
            notifications={recentActivity}
            currentPage={currentPage}
            onPageChange={this.handlePageChange}
          />
        </div>
      )
    );
  }
}

export default connect()(RecentActivity);



// WEBPACK FOOTER //
// ./src/components/admin/recent-activity/RecentActivity.js